import Vue from 'vue'
import Vuex from 'vuex'
import puexs from "@/modules/puexs";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    form: {
      basic: {
        name: "",
        category: "",
        age: "",
        height: "",
        weight: "",
        waist: "",
        pressed: "",
        relaxed: "",
        date1: "",
      },
      test: {
        protn: "",
        glucose: "",
        liverf: "-1",
        enzyme: "-1",
        kidneyf: "-1",
        fat: "-1",
      },
      opt: {
        cprotn: "-1",
        cell: "-1",
        piss: "-1",
        hearth: "-1",
        chest: "-1",
        BSonar: "-1",
      },
      bsonar: {
        liver: "-1",
        gall: "-1",
        spleen: "-1",
        pancreas: "-1",
        kidney: "-1",
        bladder: "-1",
        ureter: "-1",
        sex: "-1",
        thyroid: "-1",
        neck: "-1",
      },
    },
    demoForm: {
      basic: {
        name: "演示",
        category: "女",
        age: 51,
        height: 161,
        weight: 58,
        waist: 76,
        pressed: 111,
        relaxed: 71,
        date1: "-",
      },
      test: {
        protn: 46.3,
        glucose: 4.33,
        liverf: "0",
        enzyme: "0",
        kidneyf: "0",
        fat: "1",
      },
      opt: {
        cprotn: "-1",
        cell: "0",
        piss: "1",
        hearth: "1",
        chest: "0",
        BSonar: "0",
      },
      bsonar: {
        liver: "1",
        gall: "1",
        spleen: "0",
        pancreas: "0",
        kidney: "0",
        bladder: "-1",
        ureter: "-1",
        sex: "1",
        thyroid: "0",
        neck: "-1",
      },
      result: {
        MF: 28.571,
        OF: 36.364,
        EOI: 45.418,
        BA: 56.7,
        HI: 51.825,
        status: '良好'
      }
    }
  },
  mutations: {
    setForm(state, param: { key: 'basic' | 'test' | 'bsonar' | 'opt', data: any }) {
      state.form[param.key] = param.data;
    },
  },
  actions: {

  },
  getters: {

  },
  modules: {
  },
  plugins: [puexs]
})